import React from "react";

const TopSellingTop = () => {
    return (
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div className="_selling_nft_btn_main_left">
                        <a href="#0" className="_selling_nft_left_btn"><span className="_selling_nft_btn_main_left1_ic"><svg
                            xmlns="http://www.w3.org/2000/svg" width="12" height="13" fill="none"
                            viewBox="0 0 12 13">
                            <path fill="#000"
                                d="M6 11.225 1.094 7.38 0 8.225l6 4.656 6-4.656-1.094-.844L6 11.225Zm0-1.72 4.906-3.812L12 4.85 6 .193 0 4.85l1.094.843L6 9.506Zm0-7.624L9.813 4.85 6 7.818 2.187 4.85 6 1.88Z" />
                        </svg>
                        </span>Blockchain</a>
                        <a href="#0" className="_selling_nft_left_btn"><span className="_selling_nft_btn_main_left1_ic"><svg
                            xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none"
                            viewBox="0 0 14 14">
                            <path fill="#000"
                                d="m10.068 2.85 1.907 1.906-1.907 1.875-1.875-1.875 1.875-1.906Zm-5.093.343V5.85H2.318V3.193h2.657ZM11.63 9.85v2.656H8.975V9.85h2.656Zm-6.656 0v2.656H2.318V9.85h2.657ZM10.068.975l-3.75 3.78 3.75 3.75 3.782-3.75-3.782-3.78Zm-3.75.875H.975v5.343h5.343V1.85Zm6.657 6.656H7.63v5.344h5.344V8.506Zm-6.657 0H.975v5.344h5.343V8.506Z" />
                        </svg>

                        </span>Category</a>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div className="_selling_nft_btn_main_right">
                        <a href="#0" className="_selling_nft_left_btn">Last 7 days</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopSellingTop;